'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = require('redux-form');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _ = require('../');
var _ReportPropertyForm = require('./ReportPropertyForm.scss');var styles = _interopRequireWildcard(_ReportPropertyForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // import { connect } from 'react-redux';

// eslint-disable-next-line
var OPTIONS_LIST = {
  PHOTO: 'photo',
  ADDRESS: 'address',
  PRICE: 'price',
  DETAILS: 'details',
  CONTACTS: 'contacts',
  IRRELEVANT: 'irrelevant',
  DESCRIPTION: 'property-description',
  DUPLICATE: 'duplicate',
  OTHER: 'other' };var


ReportPropertyForm = function (_Component) {_inherits(ReportPropertyForm, _Component);function ReportPropertyForm() {var _temp, _this, _ret;_classCallCheck(this, ReportPropertyForm);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      reason: null,
      token: null }, _this.


    setOption = function (value) {return _this.setState({ reason: value }, function () {return _this.reasonInput.onChange(value);});}, _this.

    renderShadowInput = function (inputName) {return function (_ref) {var input = _ref.input;
        _this[inputName] = input;
        return null;
      };}, _this.

    renderOptions = function () {return Object.keys(OPTIONS_LIST).map(function (key) {return (
          _react2.default.createElement('li', { key: key },
            _react2.default.createElement('a', { onClick: function onClick(evt) {evt.preventDefault();_this.setOption(OPTIONS_LIST[key]);} },
              _this.props.translate(OPTIONS_LIST[key]))));});}, _temp), _possibleConstructorReturn(_this, _ret);}ReportPropertyForm.prototype.




  render = function render() {var _this2 = this;var
    translate = this.props.translate;var
    reason = this.state.reason;

    return (
      _react2.default.createElement('form', { className: (0, _classnames2.default)(styles.reportPropertyForm, this.props.className), onSubmit: this.props.handleSubmit },
        !reason &&
        _react2.default.createElement('div', null,
          _react2.default.createElement('h4', { className: 'title' }, translate('title')),

          _react2.default.createElement('ul', { className: 'options-list' },
            this.renderOptions())),




        reason &&
        _react2.default.createElement('div', null,
          _react2.default.createElement('h4', { className: 'title' }, translate('description')),

          _react2.default.createElement(_reduxForm.Field, { name: 'issue', type: 'text', component: 'textarea', placeholder: translate('descriptionPlaceholder') }),

          _react2.default.createElement(_.GoogleReCaptcha, {
            visible: true,
            fetchToken: function fetchToken(token) {return _this2.setState({ token: token }, function () {return _this2.captcha.onChange(token);});} }),


          _react2.default.createElement('button', { type: 'submit', disabled: !this.state.token },
            !this.props.reportSending ? translate('send') : _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' }))),




        _react2.default.createElement(_reduxForm.Field, { name: 'reason', component: this.renderShadowInput('reasonInput') }),
        _react2.default.createElement(_reduxForm.Field, { name: 'captcha', component: this.renderShadowInput('captcha') })));


  };return ReportPropertyForm;}(_react.Component);


ReportPropertyForm.propTypes = {
  className: _propTypes2.default.string,
  handleSubmit: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  reportSending: _propTypes2.default.bool };exports.default =


(0, _reduxForm.reduxForm)({
  form: 'reportPropertyForm' })(
ReportPropertyForm);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportPropertyForm/ReportPropertyForm.js
// module id = 2890
// module chunks = 0